import React from "react";
import AdminModulePage from "../../../components/Admin/ModulePage/AdminModulePage";

const SystemAdministration = () => {
    return <AdminModulePage moduleKey="system-administration" />;
};

export default SystemAdministration;
